import Vue from 'vue';
import Vuex from 'vuex';
import store from './store/store';
import App from './App.vue';
import router from './router';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import axiosConfig from './api/axios';
import Fragment from 'vue-fragment';
import VueI18n from 'vue-i18n';
import './assets/scss/app.scss';
import languages from './assets/translations/lang.js';
import './registerServiceWorker';

Vue.use(Vuex);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueI18n);
Vue.use(Fragment.Plugin);

Vue.config.productionTip = false;

axiosConfig();

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'en',
  fallbackLocale: 'en',
  messages: languages, // set locale messages
});

Vue.filter('date', function(date) {
  if (!date) return '';
  return new Date(date).toLocaleDateString();
});

Vue.filter('dateReadable', function(date) {
  if (!date) return '';
  return new Date(date).toLocaleDateString(
    navigator.language ||
      navigator.userLanguage ||
      this.$i18n.locale.toLowerCase(),
    { day: 'numeric', month: 'short', year: 'numeric' },
  );
});

Vue.filter('currency', function(amount, currency) {
  if (amount === '' || undefined) return '';
  return new Intl.NumberFormat(
    navigator.language ||
      navigator.userLanguage ||
      this.$i18n.locale.toLowerCase(),
    {
      style: 'currency',
      currency: currency.toUpperCase(),
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
  ).format(amount);
});

Vue.filter('currencyDecimals', function(amount, currency) {
  if (amount === '' || undefined) return '';
  return new Intl.NumberFormat(
    navigator.language ||
      navigator.userLanguage ||
      this.$i18n.locale.toLowerCase(),
    {
      style: 'currency',
      currency: currency.toUpperCase(),
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
  ).format(amount);
});

Vue.filter('currencySymbol', function(currency) {
  if (!currency) return '';
  return (
    new Intl.NumberFormat('sv', {
      style: 'currency',
      currency: currency.toUpperCase(),
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).formatToParts(0)[2]['value'] || currency
  );
});

Vue.filter('decimalSingle', function(number) {
  if (!number) return '';
  return new Intl.NumberFormat(
    navigator.language ||
      navigator.userLanguage ||
      this.$i18n.locale.toLowerCase(),
    {
      maximumFractionDigits: 1,
    },
  ).format(number);
});

const vm = new Vue({
  created() {
    document.documentElement.setAttribute(
      'lang',
      this.$i18n.locale.toLowerCase(),
    );
  },
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount('#app');

export default vm;
